import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config';
import '../styles/VaciarPicking.css';

function VaciarPicking() {
  const { token } = useAuth();
  const [rack, setRack] = useState('');
  const [shelf, setShelf] = useState('');
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState('');

  const handleSubmit = async () => {
    if (!token) {
      setResponseMessage('No hay token disponible');
      return;
    }

    if (!rack || !shelf) {
      setResponseMessage('Por favor, completa todos los campos');
      return;
    }

    // Show confirmation dialog
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas vaciar la posición de picking?\n\nRack: ${rack}\nShelf: ${shelf}\n\nEsta acción establecerá la cantidad a 0.`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/empty-picking-positions/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          rack: rack,
          shelf: shelf,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setResponseMessage('✓ ' + (data.message || 'Posición vaciada exitosamente'));
        setRack('');
        setShelf('');
      } else {
        const errorData = await response.json();
        setResponseMessage(`Error: ${errorData.error || errorData.detail || 'No se pudo vaciar la posición'}`);
      }
    } catch (error) {
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div>
      <button className="vaciar-picking-back-button" onClick={() => navigate(`/init`)}>
        &#8592;
      </button>

      <div className="vaciar-picking-container">
        <h1 className="vaciar-picking-title">Vaciar Posición de Picking</h1>
        <div className="vaciar-picking-form">
          <label htmlFor="rack" className="vaciar-picking-label">Rack:</label>
          <input
            id="rack"
            className="vaciar-picking-input"
            type="text"
            value={rack}
            onChange={(e) => setRack(e.target.value)}
            placeholder="RACK1 ó RACKFRIO1"
          />

          <label htmlFor="shelf" className="vaciar-picking-label">Casillero:</label>
          <input
            id="shelf"
            className="vaciar-picking-input"
            type="text"
            value={shelf}
            onChange={(e) => setShelf(e.target.value)}
            placeholder="A1"
          />

          <button className="vaciar-picking-button" onClick={handleSubmit}>
            Vaciar
          </button>
        </div>
        {responseMessage && <p className="vaciar-picking-message">{responseMessage}</p>}
      </div>
    </div>
  );
}

export default VaciarPicking;
